import angular from "angular"
import { NcrSummaryContainerComponent } from "./ncr-summary/ncr-summary-container.component";
import { RsCommissionsGridComponent } from "./commissions-grid/rs-commissions-grid.component";
import { PayrollAnalysisComponent } from "./payroll-analysis/payroll-analysis.component";
import { PayrollAnalysisSummaryCompactTableComponent } from "./payroll-analysis-summary/payroll-analysis-summary-compact-table.component";
import { PayrollAnalysisSummaryDetailTableComponent } from "./payroll-analysis-summary/payroll-analysis-summary-detail-table.component";
import { PayrollAnalysisSummaryComponent } from "./payroll-analysis-summary/payroll-analysis-summary.component";
import { AdpFilesDashboardComponent } from "./adp-files-dashboard/adp-files-dashboard.component";
import { PayrollReportsRoutingModule } from "./payroll-reports-routing.module";
import { WorkersCompensationDashboardComponent } from "./workers-compensation/workers-compensation-dashboard.component"

export const PayrollReportsModule = angular
    .module('apex.mainApp.payroll.reports', [
        PayrollReportsRoutingModule
    ])
    .component('apexNcrSummaryContainer', NcrSummaryContainerComponent)
    .component('apexRsCommissionsGrid', RsCommissionsGridComponent)
    .component("apexPayrollAnalysis", PayrollAnalysisComponent)
    .component("apexPayrollAnalysisSummaryCompactTable", PayrollAnalysisSummaryCompactTableComponent)
    .component("apexPayrollAnalysisSummaryDetailTable", PayrollAnalysisSummaryDetailTableComponent)
    .component("apexPayrollAnalysisSummary", PayrollAnalysisSummaryComponent)
    .component("apexAdpFilesContainer", AdpFilesDashboardComponent)
    .component("apexWorkersCompensationDashboard", WorkersCompensationDashboardComponent)
    .name
